import { render, staticRenderFns } from "./CookiePolicy.vue?vue&type=template&id=e47566d2&scoped=true&"
import script from "./CookiePolicy.vue?vue&type=script&lang=js&"
export * from "./CookiePolicy.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/static-pages/howto.scss?vue&type=style&index=0&id=e47566d2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47566d2",
  null
  
)

export default component.exports